import { useCallback, useEffect } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useSetLayer from "@/core/helpers/useSetLayer";
import { useKeyPress } from "@/core/keyPressManager";
import { layer } from "@/domains/loadingScreen/constants/layer";
import { setActiveKey } from "@/domains/activeKey/slice";
// TODO exit крашит игру, раскомментировать, когда поправят на бэке
// import useExit from "@/domains/loadingScreen/hooks/useExit";
import KeyCode from "@/assets/constants/key-code";

export default function useEscapeKeyPress() {
  const dispatch = useAppDispatch();
  const { currLayer } = useSetLayer(layer);
  const { subscribeKeyDown, unsubscribeKeyDown, subscribeKeyUp, unsubscribeKeyUp } = useKeyPress();
  // const { exit } = useExit();

  const keyDownHandler = useCallback(
    (keyCode: KeyCode) => {
      if (currLayer !== layer) return;
      switch (keyCode) {
        case KeyCode.ESCAPE: {
          dispatch(setActiveKey(null));
          break;
        }
        default:
          break;
      }
    },
    [currLayer],
  );

  useEffect(() => {
    const key = "escapeKeyDown";
    subscribeKeyDown(key, keyDownHandler);

    return () => {
      unsubscribeKeyDown(key);
    };
  }, [keyDownHandler]);

  const keyUpHandler = useCallback(
    (keyCode: KeyCode) => {
      if (currLayer !== layer) return;
      switch (keyCode) {
        case KeyCode.ESCAPE: {
          dispatch(setActiveKey(keyCode));
          // exit();
          break;
        }
        default:
          break;
      }
    },
    [currLayer],
  );

  useEffect(() => {
    const key = "escapeKeyUp";
    subscribeKeyUp(key, keyUpHandler);

    return () => {
      unsubscribeKeyUp(key);
    };
  }, [keyUpHandler]);
}
